<template>
  <!-- 优选律师 -->
  <div class="online_consult margin_auto text_center">
    <sec-title
      ac-text="在线"
      Text="法律咨询"
      desc-text="有法律疑惑，马上免费在线咨询，您的法律疑问我们来解决"
	  :showmore = 'false'
    />

    <div class="consult_top between">
      <div class="consult_tl">
        <div class="consult_form">
          <div class="hot_ify">
            <div class="ti">【热门类别】</div>
            <div class="ify_ti between FontSize14">
              <div>
                <span
                  class="text_hover_shou"
                  v-for="(item, index) in majors"
                  :key="index"
                  >{{item.name}}</span
                >
              </div>
              <div class="mo text_hover_shou">更多></div>
            </div>
          </div>
          <div class="con_form">
            <div class="ify flex_start">
              <div class="ify_l">咨询类别</div>
              <div>
                <select class="ify_r_se">
                  <option value="婚姻家庭" v-for="(item,index) in majors" :key='index'>{{item.name}}</option>
                </select>
              </div>
            </div>
            <div class="content flex_start">
              <div class="ify_l">咨询内容</div>
              <div>
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="textarea"
                  resize="none"
                  class="ify_r_text"
                >
                </el-input>
              </div>
            </div>
            <div class="submit text_hover_shou">提交</div>
          </div>
        </div>
        <div class="reply_tag">
          <div class="tagname between">
            <div class="flex_start">
              <div
                class="tag_item text_hover_shou"
                v-for="(item, index) in taglist"
                :key="index"
                :class="{ tag_item_active: index == current_tag }"
                @click="tag_click(index)"
              >
                热门回复
              </div>
            </div>
            <div class="tag_more FiseSize14 text_hover_shou">更多></div>
          </div>
          <div class="tagcontent"><home-collapse></home-collapse></div>
        </div>
      </div>
      
	  <div class="consult_tr">
		  	<div class="ti "><sub-title text="在线咨询律师"  :showmore='true'/></div>
		  
		  
		   <el-carousel ref="swiperll" indicator-position="none" arrow='never' :loop='false' :autoplay = 'false' height='280px'>
		      <el-carousel-item v-for="item in 3" :key="item">
		        
				<div  v-for="(item,index) in 2" @mouseenter="enterin(index)" @mouseleave="leaveout">
					<div class="rightitem flex_start mt20" v-if="activeindex !== index">
						<img src="../../../assets/claim/aaaa1_sample.png" >
						<div class="flex-col">
							<span class="FontSize20">徐子城律师</span>
							<span class="FontSize16 FontGray">交通事故  婚姻家庭  财务纠纷</span>
							<span class="FontSize16"><i class="el-icon-phone FontBlue"></i> 1776588112</span>
						</div>
					</div>
					<div class="itemactive flex_start mt20" v-if="activeindex == index">
						<img src="../../../assets/claim/aaaa1_sample.png" >
						<div class="flex-col inner">
							<span class="FontSize20">徐子城律师</span>
							<span class="FontSize16 FontGray">交通事故  婚姻家庭  财务纠纷</span>
							<span class="FontSize14 FontGray1" >思维敏捷缜密，具备了妥善出色处理各类案件的能力!</span>
						</div>
						<div class="btn">
							<span>在线咨询</span>
						</div>
					</div>
				</div>
				
		      </el-carousel-item>
		    </el-carousel>
		  <div class="flex center dots" style="width: 100%;height: 20px;margin-bottom: 18px;">
		  	<div 
			:class="['dot',index == swiperllindex?'dot-active':'']" 
			v-for="(item,index) in 3"
			@click="swiperll(index)"
			></div>
		  </div>
		  
       <div class="laywerreply " >
       	<div class="ti"><sub-title text="律师回复动态" /></div>
       	<lv-timeline class="timeline" :fonum="3" :spl="18" />
       </div>
      </div>
	  
    </div>
	<div class="flex between mt40">
		<div :class="['flex-col','center',laywerindex == index?'layweritem-active':'layweritem']" 
		v-for="(item , index) in 4"
		@mouseenter="enterlaywer(index)"
		@mouseleave="leavelaywer"
		>
			<img src="../../../assets/claim/aaaa1_sample.png" class="avatar">
			<div class="flex-col center mt20">
				<span class="FontSize22 mt10">徐子成 <span class="FontSize16 FontBlue">专职律师</span></span>
				<span class="FontSize16">刑事辩护、交通事故、财务纠纷</span>
				<span class="FontSize16 phone mt10"><i class="el-icon-phone FontBlue"></i> 1776588112</span>
				<span class="FontSize14 FontGray info mt10">思维敏捷缜密，妥善处理各类案件!</span>
				<div class="btn">
					立即咨询
				</div>
			</div>
		</div>
	</div>
	
    <!-- <div class="consult_advert between">
      <div class="le"><img src="~assets/home/consult_bg.png" /></div>
      <lay-item-win
        class="conslayitem"
        v-for="(item, index) in laywerlist"
        :consult-or-more="true"
        :is-border="false"
        :key="index"
		:item = 'item'
      ></lay-item-win>
    </div> -->
  </div>
</template>

<script>
import layItemWin from "../components/layItemWin";
import secTitle from "../components/secTitle";
import subTitle from "../components/subTitle";
import homeCollapse from "../components/homeCollapse";
import lvTimeline from "../components/homeTimeline/homeTimeline";
export default {
  components: {
    secTitle,
    subTitle,
    layItemWin,
    homeCollapse,
    lvTimeline,
  },
  data() {
    return {
      textarea: "",
      current_tag: 0,
      current_content: 0,
      taglist: ["热门回复", "最新提问", "精选咨询", "推荐咨询"],
	  rlist:[],
	  laywerlist:[],
	  majors:[],
	  activeindex:Infinity,
	  laywerindex : 0,
	  swiperllindex:0,
    };
  },
  created() {
  	this.$http.home.lawyerads({
  		ad_id:8,
  		limit:5,
  		order:'new'
  	}).then(res => {
  		this.laywerlist = res.data.data
  	})
	this.$http.home.lawyerads({
		ad_id:7,
		limit:5,
		order:'new'
	}).then(res => {
		this.laywe
		this.rlist = res.data.data
	})
	this.$http.home.majors().then( res => {
		this.majors = res.data
	})
  },
  methods: {
    tag_click(index) {
      this.current_tag = index;
    },
	enterin(index){
	  this.activeindex = index
	},
	leaveout(){
	  console.log('leave1')
	  this.activeindex = Infinity
	},
	enterlaywer(index){
		this.laywerindex = index
	},
	leavelaywer(){
		this.activeindex = Infinity
	},
	swiperll(index){
		this.$refs.swiperll.setActiveItem(index)
		this.swiperllindex = index
	}
  },
};
</script>


<style lang="scss" scoped>
.online_consult {
  width: 1200px;
  padding: 50px 0;
  .title {
    > .consult_title {
      display: inline;
      font-size: 38px;
      position: relative;
      > span {
        color: #0465ea;
      }
      &::after {
        content: "";
        position: absolute;
        width: 40%;
        bottom: -17px;
        left: 50%;
        transform: translateX(-50%);
        height: 3px;
        background-color: #0465ea;
      }
    }
    .consult_desc {
      margin: 30px 0;
      color: #666666;
      font-size: 20px;
    }
  }
  .consult_top {
    align-items: flex-start;
    .consult_tl {
      width: 710px;

      .consult_form {
        width: 100%;
        height: 360px;
        background: #ffffff;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.05);

        .hot_ify {
          padding: 24px 24px 16px;
          text-align: left;
          border-bottom: 1px solid #eee;
          .ti {
            color: #cb0d0e;
            margin-left: -8px;
          }
          .ify_ti {
            margin-top: 12px;
            color: #999999;
            span {
              margin-right: 12px;
              &:hover {
                color: #666;
              }
            }
            .mo {
              color: #666666;
            }
          }
        }

        .con_form {
          padding: 22px;
          font-size: 14px;
          .ify,
          .content {
            .ify_l {
              color: #666666;
              font-size: 16px;
              width: 90px;
            }
            ::v-deep .el-textarea__inner:focus {
              outline: 0;
              border-color: #c0c4cc !important;
            }

            .ify_r_se {
              width: 268px;
              height: 36px;
              line-height: 36px;
              color: #e8e8e8;
              outline: none;
              font-size: 14px;
              padding-left: 12px;
              border: 1px solid #e8e8e8;

              option {
                color: #999999;
                line-height: 36px;
                border: 1px solid #e8e8e8;
              }
            }
            .ify_r_text {
              width: 582px;
              font-size: 14px;
            }
          }
          .content {
            margin-top: 33px;
          }
          .submit {
            margin: 25px auto 0;
            width: 126px;
            height: 35px;
            line-height: 35px;
            background: #cb0d0e;
            font-size: 18px;
            color: #ffffff;
          }
        }
      }
      .reply_tag {
        margin-top: 30px;
        background-color: #fff;
        .tagname {
          height: 40px;
          line-height: 40px;
          padding-right: 26px;
          border-bottom: 1px solid #EEEEEE;
          .tag_item {
            width: 110px;
            color: #333333;
          }
          .tag_item_active {
            background-color: #0465ea;
            color: #fff;
          }
          .tag_more {
            color: #666666;
            font-size: 14px;
          }
        }
        .tagcontent {
          text-align: left;
          padding: 16px 24px;
        }
      }
    }
    .consult_tr {
      width: 460px;
      padding: 24px 20px;
      align-self: flex-start;
      .home-timeline-item__content{
    padding: 19px 0px 31px;
      }
      .ti {
        margin-bottom: 12px;
      }
      .timeline {
        margin-top: 30px;
      }
	  
	  .rightitem{
	  	width: 100%;
	  	height: 120px;
	  	border-radius: 10px;
	  	box-shadow: 5px 10px 10px #f7f7f7;
		padding-left: 16px;
	  	text-align: left;
	  	background-image: url(../../../assets/case/bg2.png);
		background-color: #ffffff;
	  	img{
	  		width: 78px;
	  		height: 78px;
	  		margin-right: 17px;
	  	}
	  }
	  .itemactive{
	  position: relative;
	  background: #fff;
	  width: 100%;
	  height: 120px;
	  align-items: flex-start;
	  border-radius: 10px;
	  box-shadow: 5px 10px 10px #f7f7f7;
	  text-align: left;
	  img{
	  	width: 40px;
	  	height: 40px;
	  	margin: 17px;
	  }	
	  .inner{
	  	height: 100%;
	  	justify-content: center;
	  }
	  .btn{
	  	position: absolute;
	  	width: 74px;
	  	height: 28px;
	  	background-color: #F25618;
	  	border-radius: 5px;
	  	text-align: center;
	  	color: #ffffff;
	  	right: 20px;
	  	top: 20px;
		cursor: pointer;
	  }}
	  .laywerreply{
		  padding: 20px 20px 10px 20px;
		  background-color: #fff;
	  }
	  
	  .dots{
		  .dot{
			  width: 8px;
			  height: 8px;
			  background: #CCD1DB;
			  border-radius: 50%;
			  margin-right: 5px;
		  }
		  .dot-active{
			  width: 25px;
			  height: 7px;
			  background: #B5BAC4;
			  border-radius: 4px;
		  }
	  }
    }
  }
  .layweritem{
	  position: relative;
	  width: 285px;
	  height: 150px;
	  background: #fff;
	  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
	  .avatar{
		  position: absolute;
		  width: 80px;
		  height: 80px;
		  top: -40px;
	  }
	  .phone{
		  display: inline;
	  }
	  .info{
		  display: none;
	  }
	  .btn{
		 display: none;
	  }
  }
  .layweritem-active{
	 position: relative;
	 width: 285px;
	 height: 175px;
	 background: #fff;
	 box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
	 .avatar{
	 		  position: absolute;
	 		  width: 80px;
	 		  height: 80px;
	 		  top: -40px;
	 } 
	 .phone{
	 	display: none;	  
	 }
	 .info{
		 display: inline;
	 }
	 .btn{
		 display: block;
	 		  width: 82px;
	 		  height: 23px;
	 		  color: #fff;
	 		  background: #F25618;
	 		  border-radius: 5px;
			  margin-top: 12px;
			  font-size: 14px;
			  cursor: pointer;
	 }
  }
  .consult_advert {
    margin-top: 30px;
    .le {
      img {
        width: 222px;
        height: 314px;
      }
    }
    .conslayitem {
      width: 222px;
      height: 314px;
    }
  }
  
  
  
}
</style>